import React, { useState, useRef, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext';

function Navbar(props) {
  const navRef = useRef();
  const [navCondition, setNavCondition] = useState(false);
  const theme = useContext(ThemeContext);


  function toggleNav() {
    if (theme.state.width < 1370) {
      const newNavCondition = !navCondition;
      setNavCondition(newNavCondition);

      document.body.classList.remove('body-nav-true', 'body-nav-false');
      document.body.classList.add(newNavCondition ? 'body-nav-true' : 'body-nav-false');
    }
  }

  return (
    <>

    <nav className={"w-full h-[20px] margin-auto flex px-4 items-center relative  open-" + navCondition}>

        <ul style={{maxWidth:1600+'px'}} ref={navRef} className={ 'nav nav-' + navCondition +" w-full nav:px-2 nav:flex absolute nav:relative top-full left-0 right-0 z-200"}>

          <li className="nav:ml-[200px] px-2.5 nav:mt-[43px]">
          <NavLink onClick={() => toggleNav() } aria-label="Estrenos" to="/estrenos" className="flex nav:inline-flex py-4 px-0.5 nav:px-2.5 lg:px-4.5 colorChange text-white  items-center">
              <span className=" mt-0.5 uppercase font-light">Estrenos</span>
            </NavLink>
        </li>
        <li className="px-2.5 nav:mt-[43px]">
        <NavLink onClick={() => toggleNav() } aria-label="Catálogo" to="/catalogo" className="flex nav:inline-flex py-4 px-0.5 nav:px-2.5 lg:px-4.5 colorChange text-white  items-center">
            <span className=" mt-0.5 uppercase font-light">Catálogo</span>
          </NavLink>
      </li>
        <li className="px-2.5 nav:mt-[43px]">
          <NavLink onClick={() => toggleNav() } to="/noticias" className="flex nav:inline-flex py-4 px-0.5 nav:px-2.5 lg:px-4.5 colorChange text-white  items-center">
              <span className=" mt-0.5 uppercase font-light">Noticias</span>
            </NavLink>
        </li>
          <li className="px-2.5 nav:mt-[43px]">
          <NavLink onClick={() => toggleNav() } aria-label="Conocenos" to="/#servicios" className="flex nav:inline-flex py-4 px-0.5 nav:px-2.5 lg:px-4.5 colorChange text-white  items-center">
              <span className=" mt-0.5 uppercase font-light">Conócenos</span>
            </NavLink>
        </li>

        <li className="px-2.5 nav:mt-[43px]">
        <NavLink onClick={() => toggleNav() } aria-label="El club" to="/theclub" className="flex nav:inline-flex py-4 px-0.5 nav:px-2.5 lg:px-4.5 colorChange text-white  items-center">
            <span className=" mt-0.5 uppercase font-light">Únete al Club AF</span>
          </NavLink>
      </li>

        <li className="px-2.5 nav:mt-[43px]">
        <NavLink onClick={() => toggleNav() } aria-label="Concurso de Guiones" to="/concurso-guiones" className="flex nav:inline-flex py-4 px-0.5 nav:px-2.5 lg:px-4.5 colorChange text-white  items-center">
            <span className=" mt-0.5 uppercase font-light">Concurso Guiones</span>
          </NavLink>
      </li>


      <li className="px-2.5 nav:mt-[43px]">
      <NavLink onClick={() => toggleNav() } aria-label="Contacto" className="flex nav:inline-flex py-4 px-0.5 nav:px-2.5 lg:px-4.5 colorChange text-white  items-center" to={"/#contacto"}>
              <span className=" mt-0.5 uppercase font-light">Contacto</span>
      </NavLink>
      </li>

      <li className="nav:hidden flex justify-center mt-4 mb-2">
        <div className="flex space-x-8">
          <a href={props.social.data[0].url} className="text-white">
            <span className="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 448 512"
                width="18">
                <path
                  d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
              </svg>
            </span>
          </a>

          <a href={props.social.data[1].url} className="text-white">
            <span className="">
              <svg xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 320 512"
            width="12">
              <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/>
          </svg>
            </span>
          </a>

          <a href={props.social.data[2].url} className="text-white">
            <span className="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 400 512"
                width="16">
                <path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"/></svg>
            </span>
          </a>

          <a href={props.social.data[3].url} className="text-white">
            <span className="">
              <svg xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 512 512"
                  width="19">
                    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
                </svg>
            </span>
          </a>

          <a href={props.social.data[4].url} className="text-white">
            <span className="">
              <svg xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 512 512"
                  width="24">
                    <path d="M365.257,67.393H95.744C42.866,67.393,0,110.259,0,163.137v134.728c0,52.878,42.866,95.744,95.744,95.744h269.513c52.878,0,95.744-42.866,95.744-95.744V163.137C461.001,110.259,418.135,67.393,365.257,67.393z M300.506,237.056l-126.06,60.123c-3.359,1.602-7.239-0.847-7.239-4.568V168.607c0-3.774,3.982-6.22,7.348-4.514l126.06,63.881C304.363,229.873,304.298,235.248,300.506,237.056z"/>
                </svg>
            </span>
          </a>
        </div>
      </li>

      <li className="hidden nav:flex px-2.5 nav:mt-[43px] social social-insta ml-auto social px-2 inline-flex justify-center items-center">
        <a href={props.social.data[0].url} className="text-white">
  <span className="">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 448 512"
      width="18">

      <path
        d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
    </svg>
  </span>
</a>
      </li>

      <li className="hidden nav:flex px-2.5 nav:mt-[43px] social social-fb px-1 inline-flex justify-center items-center ml-[12px] mr-[8px]">
        <a href={props.social.data[1].url} className="text-white">
          <span className="">
            <svg xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 320 512"
          width="12">
            <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/>
        </svg>
          </span>
        </a>
      </li>


      <li className="hidden nav:flex px-2.5 nav:mt-[43px] social social-tiktok px-1 pl-0 inline-flex justify-center items-center ml-[15px]">
        <a href={props.social.data[2].url} className="text-white">
  <span className="">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 400 512"
      width="16">
      <path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"/></svg>
  </span>
</a>
      </li>

      <li className="hidden nav:flex px-2.5 nav:mt-[43px] social social-x px-1 pl-0 inline-flex justify-center items-center ml-[15px]">
        <a href={props.social.data[3].url} className="text-white">
  <span className="">
    <svg xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 512 512"
        width="19">
          <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
      </svg>
  </span>
</a>
      </li>

      <li className="hidden nav:flex px-2.5 nav:mt-[43px] social social-youtube px-1 pl-0 inline-flex justify-center items-center ml-[15px] mr-[48px]">
        <a href={props.social.data[4].url} className="text-white">
  <span className="">
    <svg xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 512 512"
        width="26">
          <path d="M365.257,67.393H95.744C42.866,67.393,0,110.259,0,163.137v134.728c0,52.878,42.866,95.744,95.744,95.744h269.513c52.878,0,95.744-42.866,95.744-95.744V163.137C461.001,110.259,418.135,67.393,365.257,67.393z M300.506,237.056l-126.06,60.123c-3.359,1.602-7.239-0.847-7.239-4.568V168.607c0-3.774,3.982-6.22,7.348-4.514l126.06,63.881C304.363,229.873,304.298,235.248,300.506,237.056z"/>
        </svg>
  </span>
</a>
    </li>






        </ul>

        <div style={{zIndex:1000}} className="pr-4 nav:pr-8 pt-16 ml-auto nav:hidden text-white cursor-pointer">
          <a onClick={() => toggleNav() } href="#nav" className="colorChange text-white" aria-label="mobile navigation menu">
            <svg width="32" className={"w-10 h-8 navBtn open-" + navCondition}
              xmlns="http://www.w3.org/2000/svg"
              fill="#fff"
              viewBox="0 0 28 28">
                <g>

<rect  className="bar_1" height="2" width="32" x="0.5" y="0"/>

<rect  className="bar_2" height="2" width="32" x="0.5" y="7"/>

<rect  className="bar_3" height="2" width="32" x="0.5" y="14"/>

</g>            </svg>
          </a>
      </div>
    </nav>
</>
  )
}

export default Navbar
